var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1684_928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9062 4.7025C15.164 4.84909 15.3781 5.06173 15.5264 5.31851C15.6747 5.5753 15.7519 5.86697 15.75 6.1635V11.6265C15.75 12.2332 15.4177 12.7927 14.8815 13.0875L9.819 16.29C9.56802 16.4278 9.28632 16.5 9 16.5C8.71368 16.5 8.43198 16.4278 8.181 16.29L3.1185 13.0875C2.85612 12.9441 2.63709 12.7329 2.48431 12.4759C2.33152 12.2188 2.2506 11.9255 2.25 11.6265V6.16275C2.25 5.556 2.58225 4.99725 3.1185 4.7025L8.181 1.7175C8.4394 1.57502 8.72967 1.50031 9.02475 1.50031C9.31983 1.50031 9.6101 1.57502 9.8685 1.7175L14.931 4.7025H14.9062Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 9C6.75 9.59674 6.98705 10.169 7.40901 10.591C7.83097 11.0129 8.40326 11.25 9 11.25C9.59674 11.25 10.169 11.0129 10.591 10.591C11.0129 10.169 11.25 9.59674 11.25 9C11.25 8.40326 11.0129 7.83097 10.591 7.40901C10.169 6.98705 9.59674 6.75 9 6.75C8.40326 6.75 7.83097 6.98705 7.40901 7.40901C6.98705 7.83097 6.75 8.40326 6.75 9Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1684_928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings2);
export default __webpack_public_path__ + "static/media/settings-2.d7a062d67c3d6042b08a1e2dc16812e9.svg";
export { ForwardRef as ReactComponent };